module.exports = __webpack_public_path__ + "img/OST.ad5d9fa2.svg";